import MainLayout from "../../layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import DeleteModal from "../../components/modal/delete-modal";
import { TextView } from "../../components/view-form-components/text-view";
import { useEffect } from "react";
import CommentsComponent from "../../components/comments/comments";
import FileCommentComponent from "../../components/comments/file-comment";
import { api } from "../../redux/apis/api";
import { useRole } from "../../context/role/RoleContext";
import ShareModal from "../../components/modal/share-modal";

const ViewTileLayer = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useRole();
  const permission = state?.role?.tile_layer;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [shareModalShow, setShareModalShow] = useState(false);

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/tile-layer/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    api
      .post(`/tile-layer/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/tile-layers/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <ShareModal
        isOpen={shareModalShow}
        onClose={() => {
          setShareModalShow(false);
        }}
        moduleName="tile_layer"
        modulelabel="tile_layer"
      />
      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">
            Tile layer - view
          </h2>
          <div className="flex gap-3 items-center">
            {permission?.write && (
              <button
                onClick={() => {
                  setShareModalShow(true);
                }}
                className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
              >
                share
              </button>
            )}
            {permission?.write && (
              <Link
                className="px-4 py-2 bg-blue-600 text-white rounded"
                to={`/tile-layers/edit/${params?.id}`}
              >
                edit
              </Link>
            )}
            {permission?.write && (
              <button
                onClick={() => {
                  setdeleteModalShow(true);
                }}
                className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
              >
                Delete
              </button>
            )}
          </div>
        </div>
        <section className="w-full max-w-[40rem]">
          <div className="px-2">
            <TextView label={"Name"} value={data?.name} />
          </div>
          <div className="px-2">
            <TextView label={"Phone"} value={data?.name} />
          </div>
          <div className="px-2">
            <TextView label={"State"} value={data?.state?.name} />
          </div>
          <div className="px-2">
            <TextView label={"City"} value={data?.city?.name} />
          </div>
          <div className="px-2">
            <TextView label={"alternative phone"} value={data?.name} />
          </div>
          <CommentsComponent tableName={"tile_layer"} viewId={params?.id} />
          <FileCommentComponent tableName={"tile_layer"} viewId={params?.id} />
        </section>
      </section>
    </MainLayout>
  );
};

export default ViewTileLayer;
